import { AssetsUpdatePage } from '@pages';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import i18n from '@risksmart-app/i18n/src/i18n';
import type { RouteObject } from 'react-router';

import { IssueTypeMapping } from '@/utils/issueVariantUtils';

import { actionRoute } from './actionRoutes.config';
import { ParamId } from './constants';
import { issueRoute } from './issueRoutes.config';

export const assetRoute: RouteObject = {
  path: `:${ParamId.Asset}`,
  handle: {
    breadcrumbNode: {
      nodeType: Parent_Type_Enum.Asset,
      paramName: ParamId.Asset,
    },
  },
  children: [
    {
      path: '',
      element: (
        <AssetsUpdatePage activeTabId={'details'} showDeleteButton={true} />
      ),
    },
    {
      path: 'actions',
      handle: {
        title: () => i18n.format(i18n.t('action_other'), 'capitalize'),
      },
      children: [
        {
          path: '',
          element: <AssetsUpdatePage activeTabId={'actions'} />,
        },
        actionRoute,
      ],
    },
    ...Object.entries(IssueTypeMapping).map(([_, itm]) => ({
      path: itm.uriPath,
      handle: {
        title: () => i18n.t(`${itm.taxonomy}.tab_title`),
      },
      children: [
        {
          path: '',
          element: <AssetsUpdatePage activeTabId={itm.taxonomy} />,
        },
        issueRoute(itm.type),
      ],
    })),
    {
      path: 'linked-items',
      handle: {
        title: () => i18n.t('linkedItems.tab_title'),
      },
      element: <AssetsUpdatePage activeTabId={'linkedItems'} />,
    },
    {
      path: 'notification-history',
      handle: {
        title: () => i18n.t('notificationHistory.tab_title'),
      },
      element: <AssetsUpdatePage activeTabId={'notificationHistory'} />,
    },
  ],
};
